export default __webpack_public_path__ + "static/media/no-data.b1597308.svg";